"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitType = void 0;
var LimitType;
(function (LimitType) {
    LimitType["DEPOSIT"] = "deposit";
    LimitType["BET"] = "bet";
    LimitType["LOSS"] = "loss";
    LimitType["SESSION"] = "session";
    LimitType["COOLING_OFF"] = "cooling_off";
})(LimitType = exports.LimitType || (exports.LimitType = {}));
